import React from 'react';

import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { pathByRouteName } from '../../../util/routes';
import { requiredFieldArrayCheckbox } from '../../../util/validators';
import { ExternalLink, FieldCheckboxGroup } from '../../../components';

import { FormattedMessage, intlShape } from '../../../util/reactIntl';

import css from './TermsAndConditions.module.css';

// The terms checkbox of the social sign-up confirmation. Its links open the pages in a new tab,
// so the form isn't lost.
const TermsAndConditions = props => {
  const { intl } = props;
  const routeConfiguration = useRouteConfiguration();

  const termsLink = (
    <ExternalLink
      className={css.termsLink}
      href={pathByRouteName('TermsOfServicePage', routeConfiguration)}
    >
      <FormattedMessage id="AuthenticationPage.termsAndConditionsTermsLinkText" />
    </ExternalLink>
  );

  const privacyLink = (
    <ExternalLink
      className={css.privacyLink}
      href={pathByRouteName('PrivacyPolicyPage', routeConfiguration)}
    >
      <FormattedMessage id="AuthenticationPage.termsAndConditionsPrivacyLinkText" />
    </ExternalLink>
  );

  return (
    <div className={css.root}>
      <FieldCheckboxGroup
        name="terms"
        id="terms-accepted"
        optionLabelClassName={css.finePrint}
        options={[
          {
            key: 'tos-and-privacy',
            label: intl.formatMessage(
              { id: 'AuthenticationPage.termsAndConditionsAcceptText' },
              { termsLink, privacyLink }
            ),
          },
        ]}
        validate={requiredFieldArrayCheckbox(
          intl.formatMessage({ id: 'AuthenticationPage.termsAndConditionsAcceptRequired' })
        )}
      />
    </div>
  );
};

// TermsAndConditions.defaultProps = {};

TermsAndConditions.propTypes = {
  intl: intlShape.isRequired,
};

export default TermsAndConditions;
